/* eslint-disable */
import React, {useState} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FeatherIcon from 'feather-icons-react';
import { useEffect } from 'react';
import * as fileSaver from 'file-saver';

import ButtonV2 from 'components/ButtonV2';
import downloadIcon from "_assets/icons/download.svg";
import { Alert,AlertType } from "utils/Alert";
import { dataChannelCall, dataChannelEmail, dataChannelSMS, dataChannelSMSOTP, dataChannelVoice, dataChannelWhatsapp} from 'utils/listDataChannel';

// services
import channelUsageSvc from 'services/channelUsageSvc';

function DetailTransactionData(props) {
  const {channel, startDate, endDate, applicationId, isDataUsageChannel} = props;
  const [isDataDetail, setDataDetail]= useState([]);
  const [isLoadingDownload, setLoadingDownload]= useState(false);
// console.log('channels', channel, isDataUsageChannel)
  useEffect(()=> {
    if(channel){
      switch (channel) {
        case 'whatsapp':
          getUsageWhatsapp();
          break;
        case 'sms':
          getDetailSMS();
          break;
        case 'sms_otp':
          getDetailSMSOTP();
          break;
        case 'call':
          getUsageCall();
          break;
        case 'email':
          getUsageEmail();
          break;
      
        default:
          break;
      }
    }
  }, [channel, isDataUsageChannel])

  function convertStatus(item){
    switch (item) {
      case 'Submitted':
          return 'submitted'
        break;
      case 'Delivered':
          return 'delivered'
        break;
      case 'Read':
          return 'read'
        break;
      case 'Rejected':
          return 'clr-rejected'
        break;
      case 'Failed':
          return 'failed'
        break;
      case 'In Queue':
          return 'inqueue'
        break;
      case 'Sent':
          return 'sent'
        break;
      case 'Answered':
          return 'sent'
        break;
      case 'RNA':
          return 'clr-rejected'
        break;
      case 'Undelivered':
          return 'clr-rejected'
        break;
      case 'Opened':
        return 'sent'
      break;
      case 'Clicked':
        return 'inqueue'
      break;
      case 'Succes':
        return 'sent'
      break;
      case 'Failed by mail server':
        return 'failed'
      case 'Unsubscribe':
        return 'failed'
      case 'Failed by System':
        return 'failed'
      break;

      default:
        break;
    }
  }

  const downloadSchema = (channel) => {
    setLoadingDownload(true)
    switch(channel) {
      case 'whatsapp' :
        downloadUsageWhatsapp();
        break
        case 'sms' :
          downloadUsageSMS();
          break
        case 'sms_otp' :
          downloadUsageSMS();
          break
        case 'email' :
          downloadUsageEmail();
          break
        case 'call' :
          downloadUsageCall();
          break

        default :
        break
    }
  }

  const getUsageWhatsapp = async () => {
    const appId = applicationId
    const reqBody = {
      startDate: startDate,
      endDate: endDate,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosUsageWhatsapp(reqBody, appId)
      if(result.data){
        for (let index = 0; index < dataChannelWhatsapp.length; index++) {
          if(result.data.total_delivered !== null && dataChannelWhatsapp[index].name === 'Delivered'){
            dataChannelWhatsapp[index].total_transaction = result.data.total_delivered
          }
          if(result.data.total_read !== null && dataChannelWhatsapp[index].name === 'Read'){
            dataChannelWhatsapp[index].total_transaction = result.data.total_read
          }
          if(result.data.total_submitted !== null && dataChannelWhatsapp[index].name === 'Submitted'){
            dataChannelWhatsapp[index].total_transaction = result.data.total_submitted
          }
          if(result.data.total_rejected !== null && dataChannelWhatsapp[index].name === 'Rejected'){
            dataChannelWhatsapp[index].total_transaction = result.data.total_rejected
          }
          if(result.data.total_failed !== null && dataChannelWhatsapp[index].name === 'Failed'){
            dataChannelWhatsapp[index].total_transaction = result.data.total_failed
          }
        }
        setDataDetail(dataChannelWhatsapp)
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  const getDetailSMS = async () => {
    const appId = applicationId
    const reqBody = {
      startDate: startDate,
      endDate: endDate,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosUsageSMS(reqBody, appId)
      if(result.data){
        for (let index = 0; index < dataChannelSMS.length; index++) {
          if(result.data.total_sent !== null && dataChannelSMS[index].name === 'Sent'){
            dataChannelSMS[index].total_transaction = result.data.total_sent
          }
          if(result.data.total_delivered !== null && dataChannelSMS[index].name === 'Delivered'){
            dataChannelSMS[index].total_transaction = result.data.total_delivered
          }
          if(result.data.total_submitted !== null && dataChannelSMS[index].name === 'Submitted'){
            dataChannelSMS[index].total_transaction = result.data.total_submitted
          }
          if(result.data.total_failed !== null && dataChannelSMS[index].name === 'Failed'){
            dataChannelSMS[index].total_transaction = result.data.total_failed
          }
        }
        setDataDetail(dataChannelSMS)
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  const getDetailSMSOTP = async () => {
    const appId = applicationId
    const reqBody = {
      startDate: startDate,
      endDate: endDate,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosUsageSMSOTP(reqBody, appId)
      if(result.data){
        for (let index = 0; index < dataChannelSMSOTP.length; index++) {
          if(result.data.total_sent !== null && dataChannelSMSOTP[index].name === 'Sent'){
            dataChannelSMSOTP[index].total_transaction = result.data.total_sent
          }
          if(result.data.total_delivered !== null && dataChannelSMSOTP[index].name === 'Delivered'){
            dataChannelSMSOTP[index].total_transaction = result.data.total_delivered
          }
          if(result.data.total_undelivered !== null && dataChannelSMSOTP[index].name === 'Undelivered'){
            dataChannelSMSOTP[index].total_transaction = result.data.total_in_queue
          }
          if(result.data.total_submitted !== null && dataChannelSMSOTP[index].name === 'Submitted'){
            dataChannelSMSOTP[index].total_transaction = result.data.total_submitted
          }
          if(result.data.total_failed !== null && dataChannelSMSOTP[index].name === 'Failed'){
            dataChannelSMSOTP[index].total_transaction = result.data.total_failed
          }
        }
        setDataDetail(dataChannelSMSOTP)
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  const downloadUsageSMS = async () => {
    const appId = applicationId
    const reqParams = {
      startDate: startDate,
      endDate: endDate,
      application_id: applicationId
    }
    try {
      let result;
      if(channel === 'sms'){
        result = await channelUsageSvc.axiosDownloadUsageSMS(reqParams, appId)
      }else if(channel === 'sms_otp'){
        result = await channelUsageSvc.axiosDownloadUsageSMSOTP(reqParams, appId)
      }

      if(result?.data){
        let filename;
        if(channel === 'sms'){
          filename = `Report_Usage_SMS_${startDate}-${endDate}`;
        }else if(channel === 'sms_otp'){
          filename = `Report_Usage_SMS_OTP_${startDate}-${endDate}`;
        }
        let accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let blob = new Blob([result.data], { type: accept });
        fileSaver.saveAs(blob, filename);
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Report results have been downloaded successfully'
        )
      }else{
        if(!result.data) {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            error.message || error
          )
        }
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message || error
      )
    } finally {setLoadingDownload(false) }
  }

  const downloadUsageWhatsapp = async () => {
    const appId = applicationId
    const reqParams = {
      start_date: startDate,
      end_date: endDate,
      application: applicationId,
    }
    try {
      let result = await channelUsageSvc.axiosDownloadUsageWhatsapp(reqParams, appId)

      if(result?.data){
        let filename =`Report_Usage_Whatsapp_${startDate}-${endDate}`;
        
        let accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let blob = new Blob([result.data], { type: accept });
        fileSaver.saveAs(blob, filename);
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Report results have been downloaded successfully'
        )
      }else{
        if(!result.data) {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            error.message || error
          )
        }
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message || error
      )
    } finally {setLoadingDownload(false) }
  }

  // Email usage and download
  const getUsageEmail = () => {
    if(!isDataUsageChannel) return;
    for (let index = 0; index < dataChannelEmail.length; index++) {
        if(isDataUsageChannel.delivered !== null && dataChannelEmail[index].name === 'Delivered'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.delivered ?? 0
        }
        if(isDataUsageChannel.opened !== null && dataChannelEmail[index].name === 'Opened'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.opened ?? 0
        }
        if(isDataUsageChannel.clicked !== null && dataChannelEmail[index].name === 'Clicked'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.clicked ?? 0
        }
        if(isDataUsageChannel.failed !== null && dataChannelEmail[index].name === 'Failed'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.failed ?? 0
        }
        if(isDataUsageChannel.unsubscribe !== null && dataChannelEmail[index].name === 'Unsubscribe'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.unsubscribe ?? 0
        }
        if(isDataUsageChannel.failed_server !== null && dataChannelEmail[index].name === 'Failed by System'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.failed_server ?? 0
        }
        if(isDataUsageChannel.failed !== null && dataChannelEmail[index].name === 'Failed by mail server'){
          dataChannelEmail[index].total_transaction = isDataUsageChannel.failed ?? 0
        }
      }
      setDataDetail(dataChannelEmail)
  }
 
  const downloadUsageEmail = async () => {
    const appId = applicationId
    const reqParams = {
      start_date: startDate,
      end_date: endDate,
      application_id: applicationId,
    }
    try {
      let result = await channelUsageSvc.axiosDownloadUsageEmail(reqParams, appId)

      if(result?.data){
        let filename =`Report_Usage_Email_${startDate}-${endDate}`;
        
        let accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let blob = new Blob([result.data], { type: accept });
        fileSaver.saveAs(blob, filename);
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Report results have been downloaded successfully'
        )
      }else{
        if(!result.data) {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            error.message || error
          )
        }
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message || error
      )
    } finally {setLoadingDownload(false) }
  }

  // Usage CALL
  const getUsageCall = async () => {
    if(!isDataUsageChannel) return;
    for (let index = 0; index < dataChannelCall.length; index++) {
        if(isDataUsageChannel.total_in_call !== null && dataChannelCall[index].name === 'In Call'){
          dataChannelCall[index].total_transaction = isDataUsageChannel.total_in_call
        }
        if(isDataUsageChannel.total_answered !== null && dataChannelCall[index].name === 'Answered'){
          dataChannelCall[index].total_transaction = isDataUsageChannel.total_answered
        }
        if(isDataUsageChannel.total_rna !== null && dataChannelCall[index].name === 'RNA'){
          dataChannelCall[index].total_transaction = isDataUsageChannel.total_rna
        }
        if(isDataUsageChannel.total_failed !== null && dataChannelCall[index].name === 'Failed'){
          dataChannelCall[index].total_transaction = isDataUsageChannel.total_failed
        }
      }
      setDataDetail(dataChannelCall)
  }

  const downloadUsageCall = async () => {
    const appId = applicationId
    const reqParams = {
      start_date: startDate,
      end_date: endDate,
      application_id: applicationId,
    }
    try {
      let result = await channelUsageSvc.axiosDownloadUsageCall(reqParams, appId)

      if(result?.data){
        let filename =`Report_Usage_Call_${startDate}-${endDate}`;
        
        let accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let blob = new Blob([result.data], { type: accept });
        fileSaver.saveAs(blob, filename);
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Report results have been downloaded successfully'
        )
      }else{
        if(!result.data) {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            error.message || error
          )
        }
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message || error
      )
    } finally {setLoadingDownload(false) }
  }
  

  return (
    <div className="wrapper_detail_transaction">
      <div className='d-flex align-items-center justify-content-between border-bottom w-100 mb-4 pb-3'>
        <div className='cl-deep-black fweight-600 fsize-16 capitalize'>{channel === 'sms_otp' ? 'SMS OTP' : channel} Usage</div>
        <ButtonV2 
          disabled={isLoadingDownload}
          className='ms-2 d-flex align-items-center'
          handleRoute={()=>downloadSchema(channel)} 
          backgroundColor="#3B3B47"
          textColor="#FFFFFF"
          padding=".360rem 1rem"
          loadingCreate={isLoadingDownload}
        >
          <img
            src={downloadIcon}
            className="me-2"
            alt="downloadIcon" 
          />
          Export to Excel
        </ButtonV2>
      </div>
      <div className="d-flex align-items-center justify-content-between border-bottom w-100 pb-3">
        {isDataDetail && isDataDetail.map((item, index) => {
         return (
          <div key={index} className={`box d-flex flex-column align-items-center h-100 ${isDataDetail.length - 1 !== index && 'border-end'}`}>
            <div>
              <div className="d-flex align-items-center mb-2">
                <h3 
                  className={` ${convertStatus(item.name)} fweight-500 fsize-14 m-0`}
                  >
                    {item.name}
                  </h3>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-2">{item.tooltip}</Tooltip>}
                  >
                    <span className='ic_info d-flex align-items-center ms-2'>
                      <FeatherIcon className="cl-light-grey pinkic-hover" icon="info" />
                    </span>
                </OverlayTrigger>
              </div>
              <div className="cl-neutral500 fweight-600 fsize-16">{item.total_transaction}</div>
            </div>
          </div>
          )
        })}
      </div>
    </div> 
  )
}

export default DetailTransactionData